'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'house';
var width = 576;
var height = 512;
var aliases = [127968,63498,63500,"home","home-alt","home-lg-alt"];
var unicode = 'f015';
var svgPathData = ['M112 212.8L112 464l80 0 0-168 0-24 24 0 144 0 24 0 0 24 0 168 80 0 0-251.2L288 63.5 112 212.8z', 'M288 .5l15.5 13.2 264 224-31.1 36.6L512 253.5 512 488l0 24-24 0L88 512l-24 0 0-24 0-234.5L39.5 274.3 8.5 237.7l264-224L288 .5zm0 63L112 212.8 112 464l80 0 0-168 0-24 24 0 144 0 24 0 0 24 0 168 80 0 0-251.2L288 63.5zM240 464l96 0 0-144-96 0 0 144z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHouse = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;